module.exports = new __parcel__URL__("error-window-darkmode.92452aa6.svg").toString();